import { loadGroupAvatars, fetchGroupAvatar } from 'actions/AvatarActions';
import AvatarStore from 'stores/AvatarStore';
import GroupAvatarPicker from './GroupAvatarPicker.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';

import './styles/GroupAvatarSelector.scss';

const MIN_HIDDEN_AVATAR_ID = 9001;

const GroupAvatarSelector = React.createClass({
  propTypes: {
    onSelect: React.PropTypes.func.isRequired,
    initialAvatar: React.PropTypes.object,
  },

  mixins: [
    linkStateWithStores([AvatarStore]),
  ],

  getInitialState() {
    return this.getStateFromStores();
  },

  componentDidMount() {
    if (!AvatarStore.areGroupAvatarsLoaded()) {
      return loadGroupAvatars();
    }
  },

  onAvatarSelected(avatar) {
    this.setState({ avatar });
    this.props.onSelect(avatar);
  },

  getSelectedAvatar() {
    return this.state.avatar;
  },

  getSelectedAvatarId() {
    return this.state.avatar.id;
  },

  getStateFromStores() {
    let avatar = null;

    if (!this.props.initialAvatar) {
      avatar = AvatarStore.getGroupAvatars().getRandomAvatar();
    } else {
      avatar = AvatarStore.getGroupAvatars().get(this.props.initialAvatar.id);
      // HACK: In order to display hidden avatars for classes that have them selected
      if (!avatar && this.props.initialAvatar.id >= MIN_HIDDEN_AVATAR_ID) {
        avatar = this.props.initialAvatar;
      }
    }

    return {
      avatar,
    };
  },

  searchAvatarForName(name) {
    fetchGroupAvatar(name).then(avatars => {
      const avatar = avatars.first();

      if (avatar) {
        this.setState({ avatar });
      }
    });
  },

  renderAvatar() {
    return (
      <Image
        className="GroupAvatarSelector-Avatar"
        src={this.state.avatar.getUrl()}
        circle
      />
    );
  },

  renderPlaceholder() {
    return (
      <div className="GroupAvatarSelector-Placeholder" />
    );
  },

  render() {
    const groupAvatarPickerModal = (
      <GroupAvatarPicker
        onSelect={this.onAvatarSelected}
        selectedAvatar={this.state.avatar ? this.state.avatar.id : null}
      />
    );

    return (
      <div className="GroupAvatarSelector">
        <ModalTrigger modal={groupAvatarPickerModal}>
          <div>

            {this.state.avatar ?
              this.renderAvatar() :
              this.renderPlaceholder()
            }

            <div className="GroupAvatarSelector-Subtext">
              <Link href="#">
                Edit icon
              </Link>
            </div>
          </div>
        </ModalTrigger>
      </div>
    );
  },
});

export default GroupAvatarSelector;



// WEBPACK FOOTER //
// ./src/groups/components/GroupAvatarSelector.jsx